export default "__VITE_ASSET__D8ztno_A__"